import ic_exit_session from '@/assets/icons/core/ic_core_logout.svg?raw';
import ic_agenda from '@/assets/icons/modules/ic_mod_agenda.svg?raw';
import ic_chat from '@/assets/icons/modules/ic_mod_chat.svg?raw';
import ic_classroom from '@/assets/icons/modules/ic_mod_classroom.svg?raw';
import ic_enter_exit from '@/assets/icons/modules/ic_mod_enter_departure.svg?raw';
import ic_extemporaneos from '@/assets/icons/modules/ic_mod_extemporaneos.svg?raw';
import ic_home from '@/assets/icons/modules/ic_mod_home.svg?raw';
import ic_qr from '@/assets/icons/modules/ic_mod_qr.svg?raw';
import ic_report from '@/assets/icons/modules/ic_mod_report.svg?raw';
import logoApp from '@/assets/icons/brands/logo_kiditeachers_plain.svg?raw';
import { html, render } from "lit";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";
import "../../../styles/components/Menu-options.scss";
import { EEventId } from "../../data/models/Entities";
import { _ESCOLARIDAD_CONFIGURACION_MAP } from "../../data/services/Escolaridad";
import { _ESCUELA, _SvEscuelaObtenerConfiguracion } from "../../data/services/Escuela";
import { THashPath } from "../../routes/Routes";
import { _HashAssign } from "../../routes/UIManager";
import { _ScanQR } from "../../utils/Device";
import { _GetAppBuildTag } from "../../utils/General";
import _L from '../../utils/Labels';
import "../components-lit/Icon";
import "../components-lit/MenuGrid/MenuGrid";
import "../components-lit/MenuGrid/sub-component/MenuItem";
import { PrivacyPolicyModal } from "./PrivacyPolicyModal/PrivacyPolicyModal";
import "./PrivacyPolicyModal/PrivacyPolicyModal";
import { _LogoutDialog } from "../views/LogoutDialog";

interface IMenuOptions {
    id: number;
    title: string;
    icon: string;
    hash?: THashPath;
}

export class MenuOptions {

    private mainContainer: HTMLDivElement;
    private currentPage: "menu" | "about" = "menu";
    private privacyModal: PrivacyPolicyModal | null = null;
    private touchStartX = 0;
    private touchStartY = 0;

    private options: Map<THashPath, IMenuOptions> = new Map([
        ["home", { id: 1, icon: ic_enter_exit, title: _L("modulo.E/S"), hash: "home" }],
        ["classroom", { id: 2, icon: ic_classroom, title: _L("modulo.salon"), hash: "classroom" }],
        ["extemporaneo", { id: 3, icon: ic_extemporaneos, title: _L("modulo.extemp"), hash: "extemporaneo" }],
        // [EHashUI.CHAT, { id: 4, icon: ic_chat, title: _L("modulo.chat"), hash: EHashUI.CHAT }],
        ["agenda", { id: 5, icon: ic_agenda, title: _L("modulo.agenda"), hash: "agenda" }],
        ["report", { id: 6, icon: ic_report, title: _L("modulo.report"), hash: "report" }],
        // { id: 7, icon: ic_qr, title: 'QR', hash: EHashUI.QR },
        ["groups", { id: 8, icon: ic_home, title: _L("modulo.home"), hash: "groups" }],
        ["login", { id: 9, icon: ic_exit_session, title: _L("sesion.logout"), hash: "login" }],
    ]);

    private isDestroying = false;

    public _OnDestroyCallback: (() => void) | null = null;

    constructor() {
        this.mainContainer = document.createElement("div");
        this.mainContainer.className = "ui-menu-options";
        this.mainContainer.addEventListener("click", this.HandleOverlayClick);
        document.body.appendChild(this.mainContainer);

        this.SetOptions();

        let isShowQR = _ESCUELA && _ESCUELA.BolQr;
        if (isShowQR) //Agregar QR

            this.options.set("qrview", {
                id: 7, icon: ic_qr, title: _L("modulo.qr"), hash: "qrview"
            }

            );

        let itemChat = Array.from(_ESCOLARIDAD_CONFIGURACION_MAP.values()).filter(o => o.Tipo == EEventId.CHAT);

        if (itemChat.length > 0) this.options.set("chat", {
            id: 4, icon: ic_chat, title: _L("modulo.chat"), hash: "chat"
        }

        );

        this.SetOptions();
        this.AnimateIn();

        _SvEscuelaObtenerConfiguracion(() => {
            let isShowQR = _ESCUELA && _ESCUELA.BolQr;
            if (isShowQR) //Agregar QR

                this.options.set("qrview", {
                    id: 7, icon: ic_qr, title: _L("modulo.qr"), hash: "qrview"
                }

                );
            else this.options.delete("qrview");

            this.SetOptions();
        }

        );
    }

    // ============================================================
    // #region PRIVATE METHODS
    // ============================================================

    private HandleOverlayClick = () => {
        this._Destroy();
    }

    private OnPageTouchStart = (event: TouchEvent) => {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
    }

    private OnPageTouchEnd = (event: TouchEvent) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaY) > Math.abs(deltaX)) return;

        if (deltaX < 0 && this.currentPage === "menu") {
            this.currentPage = "about";
            this.SetOptions();
            return;
        }

        if (deltaX > 0 && this.currentPage === "about") {
            this.currentPage = "menu";
            this.SetOptions();
        }
    }

    private GoToPage(page: "menu" | "about") {
        if (this.currentPage === page) return;
        this.currentPage = page;
        this.SetOptions();
    }

    private OpenPrivacyModal() {
        this.privacyModal?.dispose();
        this.privacyModal = new PrivacyPolicyModal(() => {
            this.privacyModal = null;
            this.SetOptions();
        });
        this.SetOptions();
    }

    private SetOptions() {
        const resList = Array.from(this.options.values());
        resList.sort((a, b) => a.id - b.id);

        render(html`
            <div class="options-container" @click=${(event: Event) => event.stopPropagation()}>
                <div
                    class="page-slider"
                    @touchstart=${this.OnPageTouchStart}
                    @touchend=${this.OnPageTouchEnd}
                >
                    <div class="page ${this.currentPage === "menu" ? "is-active" : ""}">
                        <app-menu-grid
                            class="menu-page-grid"
                            k_minItemWidth="95px"
                            .k_maxCols=${3}
                            k_rowGap="var(--margin-default)"
                        >
                            ${resList.map((datum) => html`
                                <app-menu-item slot="menu-item" class="btn-option" @click=${() => this.OnSelectOption(datum)}>
                                    <div slot="icon" class="icon">
                                        ${unsafeSVG(datum.icon)}
                                    </div>
                                    <span slot="label">${datum.title}</span>
                                </app-menu-item>
                            `)}
                        </app-menu-grid>
                    </div>

                    <div class="page ${this.currentPage === "about" ? "is-active" : ""}">
                        <div class="about-page">
                            <div class="about-logo">
                                ${unsafeSVG(logoApp)}
                            </div>
                            <h2 class="about-name">Kidi Teachers</h2>
                            <div class="about-version">${_GetAppBuildTag()}</div>
                            <button
                                type="button"
                                class="privacy-link"
                                @click=${(event: Event) => {
                event.stopPropagation();
                this.OpenPrivacyModal();
            }}
                            >
                                Políticas de privacidad
                            </button>
                        </div>
                    </div>
                </div>

                <div class="pagination-bar" aria-label="Paginación del menú">
                    <button
                        type="button"
                        class="pager-btn ${this.currentPage === "menu" ? "is-active" : ""}"
                        aria-label="Ir al menú"
                        @click=${() => this.GoToPage("menu")}
                    ></button>
                    <button
                        type="button"
                        class="pager-btn ${this.currentPage === "about" ? "is-active" : ""}"
                        aria-label="Ir a Acerca de"
                        @click=${() => this.GoToPage("about")}
                    ></button>
                </div>

                <div class="version_tag hide">${_GetAppBuildTag()}</div>
            </div>

        `, this.mainContainer);
    }

    private async OnSelectOption(datum: IMenuOptions) {
        switch (datum.hash) {
            case "login":
                _LogoutDialog();
                break;
            case "qrview":
                _ScanQR();
                break;
            default:
                _HashAssign(datum.hash);
                break;
        }

        this._Destroy();
    }

    private AnimateIn() {
        const optionsContainer = this.mainContainer.querySelector(".options-container") as HTMLElement | null;

        this.mainContainer.getAnimations().forEach(animation => animation.cancel());
        optionsContainer?.getAnimations().forEach(animation => animation.cancel());

        this.mainContainer.animate([{
            opacity: "0"
        }

            , {
            opacity: "1"
        }

        ],
            {
                duration: 200, easing: "ease-out", fill: "forwards"
            }

        );

        optionsContainer?.animate([{
            opacity: "0", transform: "translateY(calc(-50% + 12px)) scale(0.98)"
        }

            ,
        {
            opacity: "1", transform: "translateY(-50%) scale(1)"
        }

        ],
            {
                duration: 260, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "forwards"
            }

        );
    }

    private async AnimateOut() {
        const optionsContainer = this.mainContainer.querySelector(".options-container") as HTMLElement | null;

        this.mainContainer.getAnimations().forEach(animation => animation.cancel());
        optionsContainer?.getAnimations().forEach(animation => animation.cancel());

        const overlayAnimation = this.mainContainer.animate([{
            opacity: "1"
        }

            , {
            opacity: "0"
        }

        ],
            {
                duration: 220, easing: "ease-in", fill: "forwards"
            }

        );

        const containerAnimation = optionsContainer?.animate([{
            opacity: "1", transform: "translateY(-50%) scale(1)"
        }

            ,
        {
            opacity: "0", transform: "translateY(calc(-50% + 8px)) scale(0.98)"
        }

        ],
            {
                duration: 180, easing: "ease-in", fill: "forwards"
            }

        );

        await Promise.all([overlayAnimation.finished.catch(() => undefined),
        containerAnimation?.finished.catch(() => undefined) ?? Promise.resolve(),
        ]);
    }

    // ============================================================
    // #region PUBLIC METHODS
    // ============================================================

    public _Destroy() {
        if (!this.mainContainer || this.isDestroying) return;

        this.isDestroying = true;

        this.mainContainer.removeEventListener("click", this.HandleOverlayClick);

        this.AnimateOut().finally(() => {
            this.mainContainer.remove();
        }

        );

        if (this._OnDestroyCallback) {
            this._OnDestroyCallback();
        }
    }
}